import React, { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext({ lang: "en", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("mpsound_lang") || "en");
  const setLang = (l) => { setLangState(l); localStorage.setItem("mpsound_lang", l); };
  useEffect(() => { document.documentElement.lang = lang === "gr" ? "el" : "en"; }, [lang]);
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
